import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';

import Menu from '../main/Menu';
import { RequestAccountRes, } from '../../classess/account/requestAccount.js'

import {
    badgetStatusGeneric, setDateTimeFormatGlobal, handleResponseMessageAsync, isUndNullEmp, getLanguageObj, getResponse,
    settings
} from '../../helpers/main';
import { RequestAccountService } from '../../services/auth/RequestAccountService';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { Status } from '../../classess/status/status';

const { icons, images, labels, messages, } = settings;

const currentMethod = 'RequestAccountDetails';

export default function RequestAccountDetails({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const { id, isNew, } = useParams();
    const [params] = useState({
        id: typeof id !== settings?.nativeObjs?.string ? 0 : parseInt(id),
        isNew: typeof isNew !== settings?.nativeObjs?.string ? false : isNew === 'true',
    });
    const [showData, setShowData] = useState(false);
    const [process, setProcess] = useState({ showLoading: true });

    const formats = {
        dateTime: {
            date: languageObj?.format?.date?.f1,
            default: settings.react.tempusDominus.values.begin01,
            time: languageObj?.format?.time?.type,
            timeAddHours: 4,
        },
    };
    const [requestAccount, setRequestAccount] = useState(RequestAccountRes.class({}, false,));
    const [status, setStatus] = useState(Status?.getClass({}, false,));
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region variables
            let localRequestAccount = RequestAccountRes.class({}, false);
            let localStatus = Status?.getClass({}, false);
            //#endregion variables

            //#region get data
            response = await RequestAccountService.getById({
                id: params.id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion get data

            //#region set data
            localRequestAccount = RequestAccountRes.class(response?.result?.requestAccount, false);
            localStatus = Status?.getClass(response?.result?.status, false);

            setRequestAccount(prev => ({ ...prev, ...localRequestAccount }));
            setStatus(prev => ({ ...prev, ...localStatus }));

            if (isUndNullEmp({ data: localRequestAccount, subMethod: currentMethod })?.result ||
                isUndNullEmp({ data: localRequestAccount?.id, subMethod: currentMethod })?.result ||
                localRequestAccount?.id <= 0) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.thereIsNoDataToProcess?.[languageObj?.id]}.`;
                response.urlGoTo = settings?.backend?.urls?.requestAccountMonitor;
                return;
            }
            //#endregion set data

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setShowData(response?.isSuccess && !response?.isWarning);
            setProcess(prev => ({ ...prev, showLoading: false }));

            // CSN
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: undefined,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    urlGoTo: response?.urlGoTo
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={settings?.app?.views?.main?.home} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 shadow-sm mx-1' style={{ borderRadius: '10px' }}>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.requestAccountDetails[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={settings?.backend?.urls?.requestAccountMonitor}>{labels?.requestAccountMonitor?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.requestAccountDetails[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {!process?.showLoading ? (
                            <div className='row'>
                                {showData ? (
                                    <div className='col-12'>
                                        <div className='row text-muted'>
                                            <div className='col-12'>
                                                <hr />
                                                <p style={{ textIndent: '40px' }}>
                                                    {parse(params.isNew ? messages?.requestAccountDetails.isNew.paragraph1[languageObj?.id] : messages?.requestAccountDetails.isNotNew.paragraph1[languageObj?.id])}:
                                                </p>
                                                <ul>
                                                    <li>
                                                        {parse(messages?.requestAccountDetails.paragraph2[languageObj?.id])}.
                                                    </li>
                                                    <li>
                                                        {parse(messages?.requestAccountDetails.paragraph3[languageObj?.id])}.
                                                    </li>
                                                    <li>
                                                        {parse(messages?.requestAccountDetails.paragraph4[languageObj?.id])}.
                                                    </li>
                                                </ul>
                                                <p style={{ textIndent: '40px' }}>
                                                    {parse(messages?.requestAccountDetails.paragraph5[languageObj?.id])}:
                                                </p>
                                                <hr />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-12'>

                                                <div className='card border-0 shadow-sm bg-white' style={{ borderRadius: '10px' }}>

                                                    {/*Header*/}
                                                    <div className='card-header border-bottom-0 pt-4 pb-2 bg-white'>
                                                        <div className='d-flex align-items-center mx-2'>
                                                            <div className='bg-light d-flex align-items-center justify-content-center shadow-sm mr-3' style={{ width: '45px', height: '45px', borderRadius: '50%' }}>
                                                                <img src={images?.icons?.user} alt='UserLogin' style={{ width: '25px', height: '25px' }} />
                                                            </div>
                                                            <h5 className='font-weight-bold mb-0 text-dark'>{labels?.requestAccount?.[languageObj?.id]}</h5>
                                                        </div>
                                                    </div>

                                                    <div className='card-body px-4'>
                                                        <div className='row mb-4 mt-2'>
                                                            <div className='col-12 d-flex align-items-center'>
                                                                <div className='bg-primary-light d-flex align-items-center justify-content-center mr-2 shadow-sm' style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#e7f1ff' }}>
                                                                    <i className={`${icons?.user} text-primary`} style={{ fontSize: '14px' }} />
                                                                </div>
                                                                <h6 className='text-primary font-weight-bold mb-0'>{labels?.personalInformation?.[languageObj?.id]}</h6>
                                                            </div>
                                                            <div className='col-12'>
                                                                <hr className='mt-2 mb-0' />
                                                            </div>
                                                        </div>

                                                        <dl className='row mb-4'>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                Id:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.id}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.firstName?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.firstName}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.lastName?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.lastName}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.email?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 font-weight-bold'>
                                                                <a href={`mailto:${requestAccount.userName}`}>{requestAccount.userName}</a>
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.phones?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.phoneNumber}
                                                            </dd>
                                                        </dl>

                                                        <div className='row mb-4 mt-2'>
                                                            <div className='col-12 d-flex align-items-center'>
                                                                <div className='bg-primary-light d-flex align-items-center justify-content-center mr-2 shadow-sm' style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#e7f1ff' }}>
                                                                    <i className={`${icons?.fasFa?.building} text-primary`} style={{ fontSize: '14px' }} />
                                                                </div>
                                                                <h6 className='text-primary font-weight-bold mb-0'>{labels?.companyInformation?.[languageObj?.id]}</h6>
                                                            </div>
                                                            <div className='col-12'>
                                                                <hr className='mt-2 mb-0' />
                                                            </div>
                                                        </div>

                                                        <dl className='row'>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.name?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.name}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.rif?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.rif}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.phones?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.phones}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.email?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 font-weight-bold'>
                                                                <a href={`mailto:${requestAccount.email}`}>{requestAccount.email}</a>
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.department?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.department}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.position?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {requestAccount.position}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.status?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {
                                                                    parse(badgetStatusGeneric({
                                                                        type: !isUndNullEmp({ data: status, subMethod: '' })?.result && !isUndNullEmp({ data: status.id, subMethod: '' })?.result ? status?.id : status.id,
                                                                        value: !isUndNullEmp({ data: status, subMethod: '' })?.result && !isUndNullEmp({ data: status.label, subMethod: '' })?.result ?
                                                                            labels?.[status.label]?.[languageObj?.id] :
                                                                            !isUndNullEmp({ data: status, subMethod: '' })?.result && !isUndNullEmp({ data: status.name, subMethod: '' })?.result ?
                                                                                labels?.[status.name.toLowerCase().trim()]?.[languageObj?.id] :
                                                                                '',
                                                                    }))
                                                                }
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.date?.[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {setDateTimeFormatGlobal({
                                                                    date: !isUndNullEmp({ data: requestAccount, subMethod: '' })?.result && !isUndNullEmp({ data: requestAccount.dateCreate, subMethod: '' })?.result ?
                                                                        requestAccount?.dateCreate :
                                                                        formats.dateTime.default,
                                                                    type: formats.dateTime.date,
                                                                    format: 0,
                                                                    addTime: false,
                                                                    withSeconds: false,
                                                                    subMethod: `${currentMethod} - date`,
                                                                })?.result}
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.time[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-3 text-dark font-weight-bold'>
                                                                {setDateTimeFormatGlobal({
                                                                    date: !isUndNullEmp({ data: requestAccount, subMethod: '' })?.result && !isUndNullEmp({ data: requestAccount.dateCreate, subMethod: '' })?.result ?
                                                                        requestAccount?.dateCreate :
                                                                        formats.dateTime.default,
                                                                    type: '',
                                                                    format: formats.dateTime.time,
                                                                    addTime: false,
                                                                    withSeconds: false,
                                                                    subMethod: `${currentMethod} - time`,
                                                                })?.result}
                                                            </dd>
                                                            <dt className='col-sm-3'>
                                                            </dt>
                                                            <dd className='col-sm-3'>
                                                            </dd>
                                                            <dt className='col-sm-3 text-muted text-uppercase small'>
                                                                {labels?.comment[languageObj?.id]}:
                                                            </dt>
                                                            <dd className='col-sm-9 text-dark font-weight-bold'>
                                                                {requestAccount.remark}
                                                            </dd>
                                                        </dl>
                                                    </div>

                                                    {/*Footer*/}
                                                    <div className='card-footer py-4 bg-white border-top-0 rounded-lg'>
                                                        <div className='row justify-content-center w-100 mx-0'>
                                                            <div className='col-12 col-sm-auto px-1 mb-2 mb-sm-0'>
                                                                <a href='/'
                                                                    title={labels?.home?.[languageObj?.id]}
                                                                    className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 w-100'
                                                                    style={{ borderRadius: '5px' }}>
                                                                    <i className={`${icons?.home} mr-1`} /> {labels?.home?.[languageObj?.id]}
                                                                </a>
                                                            </div>
                                                            <div className='col-12 col-sm-auto px-1'>
                                                                <a href={settings?.backend?.urls?.requestAccountMonitor}
                                                                    title={labels?.back?.[languageObj?.id]}
                                                                    className='btn btn-outline-secondary shadow-sm font-weight-bold px-4 w-100'
                                                                    style={{ borderRadius: '5px' }}>
                                                                    <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.back?.[languageObj?.id]}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </div>
                        ) : (
                            <div className='col-12 text-center text-muted'
                                hidden={!process?.showLoading}>
                                <img alt='loading'
                                    src={settings?.gifs?.normal?.circle}
                                    height={26}
                                    width={26} /> {messages?.processingPleaseWait?.[languageObj?.id]}
                            </div>
                        )}

                    </div>
                </section>

            </div>
        </div>
    )
}